module.exports = __webpack_public_path__ + "static/media/jquery.4465e4a0.svg";